import { render, staticRenderFns } from "./Transfer.vue?vue&type=template&id=5546eeb0"
import script from "./Transfer.vue?vue&type=script&lang=js"
export * from "./Transfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports